// Copyright (c) Bentley Systems
export class VariantVm {
  public id: number;
  public order: number;
  public label: string;
  public name: string;
  public isActive: boolean = false;
  public whereClause: string | undefined;

  constructor(
    id: number,
    order: number,
    label: string,
    name: string,
    whereClause: string | undefined
  ) {
    this.id = id;
    this.order = order;
    this.label = label;
    this.name = name;
    this.whereClause = whereClause;
  }
}
